import { LoginForm } from "@/components/form/LoginForm";

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
